import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { UserServiceApiService } from './user-service-api.service'

export interface UserMfaMethods {
  mfa_enabled: boolean
  methods: UserMfaMethod[]
}

export interface UserMfaMethod {
  id: number
  mfa_method: string
  enrollment_status: string
}

@Injectable({
  providedIn: 'root',
})
export class UserMfaMethodsService {
  public endpoint = 'v3/user_mfa_methods'

  constructor(
    private api: UserServiceApiService
  ) {
    // noop
  }

  public mine(): Observable<UserMfaMethods> {
    return this.api.get<UserMfaMethods>(
      this.endpoint
    ).pipe(
      map(response => response.result)
    )
  }

  public reset(): Observable<void> {
    return this.api.post<void>(
      `${this.endpoint}/reset`,
      {}
    ).pipe(
      map(() => undefined)
    )
  }
}
